// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';

// Internal Dependencies
import PrivateRouteAdmin from '../routing/PrivateRoute';
import Outlets from './outlets/listing';
import OutletInfo from './outlets/info';
import PageInfo from './pageInfo';
import PostListing from './posts/listing';
import ReviewListing from './reviews/listing';
import OpeningHoursPage from './openingHours/openingHoursPage';
import Photos from './photos';
import Snapstyr from './snapstyr';
import Albums from './albums';
import PageStatus from './status';
import PinnedPostListing from './pinnedPosts/listing';
import GenericHighlight from './pageHighlight/generic';
import FoodReviewHighlight from './pageHighlight/foodReview';
import PageHighlightListing from './pageHighlight/listing';
import GeographicBoundary from './geographicBoundary';
import PagePartnerBuildings from './partnerBuildings';
import FeatureControl from './featureControl';
import VouchersAndCouponsListing from './vouchersAndCoupons/listing';
import LoyaltyCards from './loyaltyCards';
import PromoCodes from './promoCodes/Index';
import LuckyDraws from './luckyDraws';
import Trails from './trails';

const Routes = ({ match }) => (
  <Switch>
    <PrivateRouteAdmin exact path={`${match.path}/posts`} component={PostListing} />
    <PrivateRouteAdmin exact path={`${match.path}/outlets/add`} component={OutletInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/outlet/:outletId`} component={OutletInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/outlets`} component={Outlets} />
    <PrivateRouteAdmin exact path={`${match.path}/openinghours`} component={OpeningHoursPage} />
    <PrivateRouteAdmin exact path={`${match.path}/photos`} component={Photos} />
    <PrivateRouteAdmin exact path={`${match.path}/albums`} component={Albums} />
    <PrivateRouteAdmin exact path={`${match.path}/snapstyr`} component={Snapstyr} />
    <PrivateRouteAdmin exact path={`${match.path}/status`} component={PageStatus} />
    <PrivateRouteAdmin exact path={`${match.path}`} component={PageInfo} />
    <PrivateRouteAdmin exact path={`${match.path}/pinnedPosts`} component={PinnedPostListing} />
    <PrivateRouteAdmin exact path={`${match.path}/reviews`} component={ReviewListing} />
    <PrivateRouteAdmin exact path={`${match.path}/genericHighlight`} component={GenericHighlight} />
    <PrivateRouteAdmin exact path={`${match.path}/foodReviewHighlight`} component={FoodReviewHighlight} />
    <PrivateRouteAdmin exact path={`${match.path}/highlights`} component={PageHighlightListing} />
    <PrivateRouteAdmin exact path={`${match.path}/geographicBoundary`} component={GeographicBoundary} />
    <PrivateRouteAdmin exact path={`${match.path}/partnerBuildings`} component={PagePartnerBuildings} />
    <PrivateRouteAdmin exact path={`${match.path}/featureControl`} component={FeatureControl} />
    <PrivateRouteAdmin exact path={`${match.path}/vouchers-coupons`} component={VouchersAndCouponsListing} />
    <PrivateRouteAdmin exact path={`${match.path}/loyaltyCards`} component={LoyaltyCards} />
    <PrivateRouteAdmin exact path={`${match.path}/promo-codes`} component={PromoCodes} />
    <PrivateRouteAdmin exact path={`${match.path}/luckyDraws`} component={LuckyDraws} />
    <PrivateRouteAdmin exact path={`${match.path}/trails`} component={Trails} />
  </Switch>
);

export default Routes;

Routes.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};
